import { z } from 'zod'

export const declarePlatformStockSchema = z.object({
  productReference: z.string().trim().min(1),
  storeReference: z.string().trim().min(1),
  lot: z.string().trim().min(1),
  quantity: z.number().int().min(0),
})

export const indexPlatformStocksSchema = z.object({
  storeReference: z.string().optional(),
  internalCategoryIds: z.array(z.coerce.number().int().positive()).optional(),
  search: z.string().optional(),
  page: z.coerce.number().int().positive().optional(),
  pageSize: z.coerce.number().int().positive().optional(),
})

export type DeclarePlatformStockInput = z.infer<typeof declarePlatformStockSchema>
export type IndexPlatformStocksInput = z.infer<typeof indexPlatformStocksSchema>
